const Support = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "0 auto" }}>
      <h1>Support</h1>

      <div style={{ marginBottom: "20px" }}>
        <h2>Contact Us</h2>
        <p>
          For support, questions, or feedback, please contact us at:
          <br />
          <a
            href="mailto:support@experienceapp.io"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            support@experienceapp.io
          </a>
        </p>
      </div>

      <div>
        <h2>About the App</h2>
        <p>
          This app was inspired by <strong>flow psychology</strong>, a concept
          developed by
          <strong> Mihaly Csikszentmihalyi</strong>. Flow is the mental state of
          complete absorption in an activity, where you feel fully focused and
          energized.
        </p>
        <p>
          Learn more about flow psychology:
          <a
            href="https://en.wikipedia.org/wiki/Flow_(psychology)"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            Wikipedia - Flow (psychology)
          </a>
        </p>
      </div>
    </div>
  );
};

export default Support;
